import React, { useState, useEffect } from 'react';
import { Outlet, useNavigate } from 'react-router-dom';
import { Layout, Menu, Typography, Button, Space, Card } from 'antd';
import {
  DashboardOutlined,
  EnvironmentOutlined,
  CalendarOutlined,
  AppstoreOutlined,
  CompassOutlined,
  UserOutlined,
  DollarOutlined,
  BookOutlined,
  SettingOutlined,
} from '@ant-design/icons';
import { signOut, getCurrentUser } from '../services/authService';
import { getUserProfile } from '../services/userService';
import { getSettings } from '../services/settingsService';
import { getCurrentDestination } from '../services/destinationsService';

const { Sider, Content } = Layout;
const { Text } = Typography;

function Admin() {
  const [userEmail, setUserEmail] = useState('');
  const [userProfile, setUserProfile] = useState(null);
  const [settings, setSettings] = useState(null);
  const [projectTitle, setProjectTitle] = useState('Projects');
  const [city, setCity] = useState();
  const navigate = useNavigate();

  useEffect(() => {
    fetchData();
  }, []);

  async function fetchData() {
    const cityData = await getCurrentDestination();
    setCity(cityData);
    window.document.title = `${cityData.name}` || 'Admin';
  }

  const menuItems = [
    {
      key: 'dashboard',
      label: 'Dashboard',
      icon: <DashboardOutlined />,
      path: '/admin',
    },
    {
      key: 'places',
      label: 'Places',
      icon: <EnvironmentOutlined />,
      path: '/admin/places',
    },
    {
      key: 'events',
      label: 'Events',
      icon: <CalendarOutlined />,
      path: '/admin/events',
    },
    {
      key: 'categories',
      label: 'Categories',
      icon: <AppstoreOutlined />,
      path: '/admin/categories',
    },
    {
      key: 'tours',
      label: 'Tours',
      icon: <CompassOutlined />,
      path: '/admin/tours',
    },

    // {
    //   key: "docs",
    //   label: "Docs",
    //   icon: <BookOutlined />,
    //   path: "/admin/docs",
    // },
    // {
    //   key: "users",
    //   label: "Users",
    //   icon: <UserOutlined />,
    //   path: "/admin/users",
    // },
  ];

  let crmMenuItems = [
    {
      key: 'contacts',
      label: 'Contacts',
      icon: <UserOutlined />,
      path: '/admin/contacts',
      group: 'crm',
    },
    {
      key: 'projects',
      label: projectTitle,
      icon: <AppstoreOutlined />,
      path: '/admin/projects',
      group: 'crm',
    },
  ];

  const settingsMenuItems = [
    {
      key: 'billing',
      label: 'Billing',
      icon: <DollarOutlined />,
      path: '/admin/billing',
    },
    {
      key: 'settings',
      label: 'Settings',
      icon: <SettingOutlined />,
      path: '/admin/settings',
    },
  ];

  useEffect(() => {
    const fetchSettings = async () => {
      try {
        const data = await getSettings();

        setSettings(data);
        const projectTitleSetting = data.find(setting => setting.key === 'projects_title');
        setProjectTitle(projectTitleSetting?.value || 'Projects');
      } catch (err) {
        console.error(err);
      }
    };

    fetchSettings();

    const getUserInfo = async () => {
      const user = await getCurrentUser();
      if (user?.email) {
        setUserEmail(user.email);
        const profile = await getUserProfile(user.id);
        setUserProfile(profile);
      }
    };
    getUserInfo();
  }, []);
  return (
    <Layout style={{ minHeight: '100vh', padding: 0 }}>
      <Sider
        width={240}
        theme="light"
        style={{
          minHeight: '100vh',
          padding: 0,
          backgroundColor: '#F5F5F5',
          position: 'fixed',
        }}
      >
        <div style={{ padding: 16 }}>
          <Typography.Title level={5} style={{ margin: 0 }}>
            {city ? city.name : 'Admin'}{' '}
          </Typography.Title>
        </div>
        <div
          style={{
            paddingBottom: 4,
            paddingLeft: 16,
            width: '75%',
            marginTop: 'auto',
            fontWeight: 600,
            color: '#777',
          }}
        >
          CRM
        </div>
        <Menu
          mode="inline"
          about="crm"
          style={{ backgroundColor: '#F5F5F5', borderRight: 0 }}
          items={crmMenuItems.map(item => ({
            ...item,
            onClick: () => navigate(item.path),
          }))}
        />
        <div
          style={{
            paddingTop: 14,
            paddingBottom: 4,
            paddingLeft: 16,
            width: '75%',
            marginTop: 'auto',
            fontWeight: 600,
            color: '#777',
          }}
        >
          Content
        </div>
        <Menu
          mode="inline"
          activeKey="content"
          style={{ backgroundColor: '#F5F5F5', borderRight: 0 }}
          items={menuItems.map(item => ({
            ...item,
            onClick: () => navigate(item.path),
          }))}
        />
        <div
          style={{
            paddingTop: 14,
            paddingBottom: 4,
            paddingLeft: 16,
            width: '75%',
            marginTop: 'auto',
            fontWeight: 600,
            color: '#777',
          }}
        >
          Settings
        </div>
        <Menu
          mode="inline"
          content="settings"
          style={{ backgroundColor: '#F5F5F5', borderRight: 0 }}
          items={settingsMenuItems.map(item => ({
            ...item,
            onClick: () => navigate(item.path),
          }))}
        />{' '}
        <div style={{ padding: 16, marginTop: 'auto', cursor: 'pointer' }}>
          <Space direction="vertical" style={{ width: '100%' }}>
            <Card
              block
              onClick={() => navigate('/admin/profile')}
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: '8px',
              }}
            >
              <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                {userProfile?.image_url ? (
                  <div style={{ paddingTop: 4 }}>
                    <img
                      src={userProfile.image_url}
                      alt="Profile"
                      style={{
                        width: '34px',
                        height: '34px',
                        borderRadius: '25%',
                        objectFit: 'cover',
                      }}
                    />
                  </div>
                ) : (
                  <UserOutlined />
                )}
                <div style={{ fontWeight: 600 }}>
                  <div>{userProfile?.username || 'Profile Settings'}</div>
                  <div>{userEmail}</div>
                </div>
              </div>
            </Card>
            <Button
              block
              onClick={async () => {
                await signOut();
                window.location.href = '/admin/login';
              }}
            >
              Logout
            </Button>
          </Space>
        </div>
      </Sider>

      <Content style={{ marginLeft: 244, padding: 24 }}>
        <Outlet />
      </Content>
    </Layout>
  );
}

export default Admin;
